import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

/**
 * Componente de Breadcrumb
 * @param {Array} listCrumbs - Array de objetos com {label, link, params}
 * @param {ReactNode} children - Componente filho
 */
export const Breadcrumb = ({ listCrumbs = [], children }) => {
  const params = useParams();

  // Processa os breadcrumbs substituindo parâmetros
  const processedCrumbs = listCrumbs.map(crumb => {
    let label = crumb.label;
    let link = crumb.link;

    // Substitui parâmetros no label e link
    if (crumb.params && crumb.params.length > 0) {
      crumb.params.forEach(param => {
        const paramValue = params[param];
        label = label.replace(`{${param}}`, paramValue || '');
        if (link) {
          link = link.replace(`{${param}}`, paramValue || '');
        }
      });
    }

    return {
      ...crumb,
      label,
      link,
    };
  });

  const breadcrumbItems = [
    {
      title: (
        <Link to="/">
          <HomeOutlined />
        </Link>
      ),
    },
    ...processedCrumbs.map((crumb, index) => ({
      title: crumb.link ? (
        <Link to={crumb.link}>{crumb.label}</Link>
      ) : (
        <span>{crumb.label}</span>
      ),
    })),
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, flex: 1 }}>
      <AntBreadcrumb items={breadcrumbItems} />
      {children}
    </div>
  );
};



